import React, { useRef, useEffect } from 'react';
import './ProgressTimeline.css';

interface ProgressTimelineItemProps {
  date: string;
  children: React.ReactNode;
  onClick?: () => void;
}

interface ProgressTimelineProps {
  children: React.ReactNode;
}

/**
 * 项目进展时间线容器
 */
export const ProgressTimeline: React.FC<ProgressTimelineProps> = ({ children }) => {
  return <div className="progress-timeline">{children}</div>;
};

/**
 * 项目进展时间线项目
 * 圆点与日期对齐，线与卡片对齐
 */
export const ProgressTimelineItem: React.FC<ProgressTimelineItemProps> = ({
  date,
  children,
  onClick,
}) => {
  const itemRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const lineRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateLineHeight = () => {
      if (itemRef.current && contentRef.current && lineRef.current) {
        const itemTop = itemRef.current.getBoundingClientRect().top;
        const contentTop = contentRef.current.getBoundingClientRect().top;
        const contentBottom = contentRef.current.getBoundingClientRect().bottom;
        
        const lineTop = contentTop - itemTop;
        const lineHeight = contentBottom - contentTop;
        
        lineRef.current.style.top = `${lineTop}px`;
        lineRef.current.style.height = `${lineHeight}px`;
      }
    };

    updateLineHeight();
    
    // 监听窗口大小变化和内容变化
    window.addEventListener('resize', updateLineHeight);
    const observer = new ResizeObserver(updateLineHeight);
    if (itemRef.current) {
      observer.observe(itemRef.current);
    }
    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      window.removeEventListener('resize', updateLineHeight);
      observer.disconnect();
    };
  }, [children]);

  return (
    <div
      ref={itemRef}
      className={`progress-timeline-item ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
    >
      <div className="progress-timeline-date">{date}</div>
      <div ref={contentRef} className="progress-timeline-content">{children}</div>
      <div ref={lineRef} className="progress-timeline-line" />
    </div>
  );
};

